const newgameCore = {
  th: {
    ng: {
      clipboard: {
        success: "คัดลอกสำเร็จ",
        unavailable: "ยังไม่มีข้อมูลให้คัดลอก",
        reload: "กรุณาปิดหน้าต่างนี้ แล้วเปิดข้อมูลอีกครั้งเพื่อลองใหม่",
        manualTitle: "กรุณาคัดลอกด้วยตนเอง",
        manualHelp: "เบราว์เซอร์ไม่อนุญาตให้คัดลอกอัตโนมัติ กดค้างที่ข้อความแล้วเลือกคัดลอก หรือกด Ctrl+C / ⌘C จากนั้นปิดหน้าต่างเพื่อทำรายการต่อ",
        value: "ข้อความที่ต้องการคัดลอก",
        retry: "ลองคัดลอกอีกครั้ง",
        close: "ปิด",
      },
      language: {
        change: "เปลี่ยนภาษา",
        current: "ภาษาปัจจุบัน: {{language}}",
        menu: "เลือกภาษา",
        selected: "เลือกภาษา {{language}} แล้ว",
      },
      core: {
        memberActions: "การทำงานสมาชิก",
        guestActions: "การเข้าสู่ระบบและภาษา",
        openMemberMenu: "เปิดเมนูสมาชิก",
        closeMemberMenu: "ปิดเมนูสมาชิก",
        freeCreditActivity: "กิจกรรมเครดิตฟรี",
        accountInfo: "ข้อมูลบัญชี",
        depositWithdraw: "ฝาก-ถอน",
        welcome: "ยินดีต้อนรับเข้าสู่เว็บคาสิโนออนไลน์ No.1 {{name}}",
        memberMenu: "เมนูสมาชิก",
        announce: "ประกาศ:",
        maintenance: "ปิดปรับปรุง",
        noGames: "ไม่พบรายการ",
        play: "เข้าเล่น",
        loading: "กำลังโหลด....",
        creditHistory: "ประวัติการเติมเครดิต",
        sorryInconvenience: "ขออภัยในความไม่สะดวกด้วยค่ะ",
        maintenanceMessage: "อยู่ในระหว่างการปิดปรับปรุง ⚠️ ขออภัยในความไม่สะดวกด้วยค่ะ",
        accessDeniedImage: "ไม่อนุญาตให้เข้าถึงหน้านี้",
        chooseCorrectPath: "ไม่พบหน้าที่ต้องการ กรุณาเลือกเส้นทางที่ถูกต้อง",
        comingSoon: "เร็ว ๆ นี้",
        promotionBalanceNote: "หมายเหตุ: หากยอดฝากของลูกค้าได้รับโปรโมชั่น และระบบตรวจพบว่ามีเครดิตคงเหลือมากกว่า 1 บาท หรือมีเดิมพันค้างอยู่ในเกมก่อนฝากยอดใหม่ บริษัทขอสงวนสิทธิ์ปฏิเสธการถอนหรือเรียกคืนเครดิตตามดุลยพินิจของผู้ดูแลระบบ",
        bestOnlineLottery: "{{name}} หวยออนไลน์ที่ดีที่สุด",
        bestOnlineCasino: "{{name}} คาสิโนออนไลน์ที่ดีที่สุด",
        lotteryFooterDescription: "{{name}} เว็บหวยออนไลน์ สล็อต บอล บาคาร่า ชั้นนำในประเทศไทย ฝาก-ถอนอัตโนมัติรวดเร็ว ใช้งานง่าย รองรับการฝากด้วยสลิป และให้บริการอย่างมั่นคง",
        casinoFooterDescription: "{{name}} เว็บสล็อต บอล บาคาร่า ชั้นนำในประเทศไทย ฝาก-ถอนอัตโนมัติรวดเร็ว ใช้งานง่าย รองรับการฝากด้วยสลิป และให้บริการอย่างมั่นคง",
        tags: "แท็ก",
        casinoPartners: "พาร์ตเนอร์คาสิโน",
        acceptedPayments: "ช่องทางชำระเงินที่รองรับ",
        partnerLogo: "โลโก้พาร์ตเนอร์คาสิโน",
        bankLogo: "โลโก้ธนาคาร {{bank}}",
        enablePoints: "เปิดระบบการรับคะแนน",
        depositForPoint: "ฝากเงิน {{amount}} บาท รับทันที 1 คะแนน",
        redemptionHistory: "ประวัติการแลก",
        rewardList: "รายการของรางวัล",
        noRewardHistory: "ไม่มีรายการแลกของรางวัล",
        promotionImage: "รูปโปรโมชั่น {{name}}",
        rewardImage: "รูปของรางวัล {{name}}",
        enterFreeCreditCode: "กรอกโค้ดเพื่อรับเครดิตฟรี",
        enterFreePointCode: "กรอกโค้ดเพื่อรับคะแนนฟรี",
        freeBonus: "โบนัสฟรี",
        bonusValidity: "เริ่มใช้งาน {{start}} สิ้นสุด {{end}}",
        fixedDepositImage: "รายละเอียดโบนัสฝากประจำ",
        dayNumber: "วันที่ {{day}}",
        tryAgainLater: "ลองใหม่อีกครั้งในภายหลัง!",
        congratulations: "ยินดีด้วย!",
        receivedCredits: "คุณได้รับ {{amount}} เครดิต",
        spinWheelWithPoints: "คลิกหมุนวงล้อ (มี {{points}} คะแนน)",
        earnPointRule: "ฝาก {{amount}} บาทขึ้นไป รับ 1 คะแนน",
        spinCostRule: "ใช้ {{points}} คะแนน เพื่อหมุนวงล้อ 1 ครั้ง",
      },
    },
  },
  en: {
    ng: {
      clipboard: {
        success: "Copied successfully",
        unavailable: "Nothing to copy yet",
        reload: "Close this window and reopen the details to try again.",
        manualTitle: "Please copy manually",
        manualHelp: "Your browser blocked automatic copying. Press and hold the text and choose Copy, or press Ctrl+C / ⌘C. Close this window to continue.",
        value: "Text to copy",
        retry: "Try copying again",
        close: "Close",
      },
      language: {
        change: "Change language",
        current: "Current language: {{language}}",
        menu: "Choose a language",
        selected: "{{language}} selected",
      },
      core: {
        memberActions: "Member actions",
        guestActions: "Login and language options",
        openMemberMenu: "Open member menu",
        closeMemberMenu: "Close member menu",
        freeCreditActivity: "Free Credit Activity",
        accountInfo: "Account Information",
        depositWithdraw: "Deposit / Withdraw",
        welcome: "Welcome to the No.1 online casino, {{name}}",
        memberMenu: "Member menu",
        announce: "Announcement:",
        maintenance: "Under Maintenance",
        noGames: "No games found",
        play: "Play",
        loading: "Loading...",
        creditHistory: "Credit History",
        sorryInconvenience: "We apologize for the inconvenience.",
        maintenanceMessage: "This service is under maintenance ⚠️ We apologize for the inconvenience.",
        accessDeniedImage: "Access denied",
        chooseCorrectPath: "Page not found. Please choose a valid path.",
        comingSoon: "Coming soon",
        promotionBalanceNote: "Note: If a deposit receives a promotion and the system finds more than THB 1 in remaining credit or an unsettled game bet before another deposit, the company reserves the right to reject the withdrawal or reclaim credit at an administrator's discretion.",
        bestOnlineLottery: "{{name}}, the best online lottery",
        bestOnlineCasino: "{{name}}, the best online casino",
        lotteryFooterDescription: "{{name}} is a leading Thai online lottery, slots, sports, and baccarat site with fast automated deposits and withdrawals, easy slip deposits, and reliable service.",
        casinoFooterDescription: "{{name}} is a leading Thai slots, sports, and baccarat site with fast automated deposits and withdrawals, easy slip deposits, and reliable service.",
        tags: "Tags",
        casinoPartners: "Casino Partners",
        acceptedPayments: "Accepted Payment Methods",
        partnerLogo: "Casino partner logo",
        bankLogo: "{{bank}} bank logo",
        enablePoints: "Enable point collection",
        depositForPoint: "Deposit {{amount}} THB and receive 1 point immediately",
        redemptionHistory: "Redemption History",
        rewardList: "Rewards",
        noRewardHistory: "No reward redemptions",
        promotionImage: "{{name}} promotion",
        rewardImage: "{{name}} reward",
        enterFreeCreditCode: "Enter a code to receive free credit",
        enterFreePointCode: "Enter a code to receive free points",
        freeBonus: "Free Bonus",
        bonusValidity: "Valid from {{start}} until {{end}}",
        fixedDepositImage: "Fixed deposit bonus details",
        dayNumber: "Day {{day}}",
        tryAgainLater: "Please try again later!",
        congratulations: "Congratulations!",
        receivedCredits: "You received {{amount}} credits",
        spinWheelWithPoints: "Spin the wheel ({{points}} points available)",
        earnPointRule: "Deposit {{amount}} THB or more to receive 1 point",
        spinCostRule: "Use {{points}} points for 1 wheel spin",
      },
    },
  },
  cn: {
    ng: {
      clipboard: {
        success: "复制成功",
        unavailable: "暂无可复制的内容",
        reload: "请关闭此窗口并重新打开详情后重试。",
        manualTitle: "请手动复制",
        manualHelp: "浏览器阻止了自动复制。请长按文本并选择复制，或按 Ctrl+C / ⌘C，然后关闭此窗口继续操作。",
        value: "要复制的文本",
        retry: "重新复制",
        close: "关闭",
      },
      language: {
        change: "切换语言",
        current: "当前语言：{{language}}",
        menu: "选择语言",
        selected: "已选择{{language}}",
      },
      core: {
        memberActions: "会员操作",
        guestActions: "登录和语言选项",
        openMemberMenu: "打开会员菜单",
        closeMemberMenu: "关闭会员菜单",
        freeCreditActivity: "免费额度活动",
        accountInfo: "账户信息",
        depositWithdraw: "存款 / 提款",
        welcome: "欢迎来到排名第一的在线赌场 {{name}}",
        memberMenu: "会员菜单",
        announce: "公告：",
        maintenance: "维护中",
        noGames: "未找到游戏",
        play: "进入游戏",
        loading: "加载中...",
        creditHistory: "额度记录",
        sorryInconvenience: "给您带来不便，敬请谅解。",
        maintenanceMessage: "系统正在维护中 ⚠️ 给您带来不便，敬请谅解。",
        accessDeniedImage: "禁止访问",
        chooseCorrectPath: "找不到页面，请选择有效路径。",
        comingSoon: "即将推出",
        promotionBalanceNote: "注意：若存款已领取优惠，且系统在再次存款前发现账户余额超过 1 泰铢或游戏中仍有未结算投注，公司保留拒绝提款或由管理员酌情收回额度的权利。",
        bestOnlineLottery: "{{name}}，优质在线彩票平台",
        bestOnlineCasino: "{{name}}，优质在线赌场",
        lotteryFooterDescription: "{{name}} 是泰国领先的在线彩票、老虎机、体育和百家乐平台，提供快速自动存提款、便捷的凭证存款及稳定可靠的服务。",
        casinoFooterDescription: "{{name}} 是泰国领先的老虎机、体育和百家乐平台，提供快速自动存提款、便捷的凭证存款及稳定可靠的服务。",
        tags: "标签",
        casinoPartners: "赌场合作伙伴",
        acceptedPayments: "支持的付款方式",
        partnerLogo: "赌场合作伙伴标志",
        bankLogo: "{{bank}} 银行标志",
        enablePoints: "启用积分收集",
        depositForPoint: "存款 {{amount}} 泰铢，立即获得 1 积分",
        redemptionHistory: "兑换记录",
        rewardList: "奖励列表",
        noRewardHistory: "暂无奖励兑换记录",
        promotionImage: "{{name}} 优惠图片",
        rewardImage: "{{name}} 奖励图片",
        enterFreeCreditCode: "输入代码领取免费额度",
        enterFreePointCode: "输入代码领取免费积分",
        freeBonus: "免费奖励",
        bonusValidity: "有效期：{{start}} 至 {{end}}",
        fixedDepositImage: "定期存款奖励详情",
        dayNumber: "第 {{day}} 天",
        tryAgainLater: "请稍后重试！",
        congratulations: "恭喜！",
        receivedCredits: "您获得了 {{amount}} 额度",
        spinWheelWithPoints: "点击转盘（现有 {{points}} 积分）",
        earnPointRule: "存款满 {{amount}} 泰铢可获得 1 积分",
        spinCostRule: "使用 {{points}} 积分可转动转盘 1 次",
      },
    },
  },
  mm: {
    ng: {
      clipboard: {
        success: "ကူးယူပြီးပါပြီ",
        unavailable: "ကူးယူရန် အချက်အလက် မရှိသေးပါ",
        reload: "ဤဝင်းဒိုးကို ပိတ်ပြီး အချက်အလက်များကို ပြန်ဖွင့်၍ ထပ်စမ်းပါ။",
        manualTitle: "ကိုယ်တိုင် ကူးယူပေးပါ",
        manualHelp: "ဘရောက်ဆာက အလိုအလျောက် ကူးယူခြင်းကို ပိတ်ထားပါသည်။ စာသားကို ဖိထားပြီး ကူးယူရန်ကို ရွေးပါ သို့မဟုတ် Ctrl+C / ⌘C ကို နှိပ်ပါ။ ဆက်လုပ်ရန် ဤဝင်းဒိုးကို ပိတ်ပါ။",
        value: "ကူးယူမည့် စာသား",
        retry: "ထပ်မံကူးယူရန်",
        close: "ပိတ်ရန်",
      },
      language: {
        change: "ဘာသာစကားပြောင်းရန်",
        current: "လက်ရှိဘာသာစကား: {{language}}",
        menu: "ဘာသာစကားရွေးချယ်ရန်",
        selected: "{{language}} ကို ရွေးချယ်ပြီးပါပြီ",
      },
      core: {
        memberActions: "အဖွဲ့ဝင် လုပ်ဆောင်ချက်များ",
        guestActions: "အကောင့်ဝင်ခြင်းနှင့် ဘာသာစကား ရွေးချယ်မှုများ",
        openMemberMenu: "အဖွဲ့ဝင်မီနူး ဖွင့်ရန်",
        closeMemberMenu: "အဖွဲ့ဝင်မီနူး ပိတ်ရန်",
        freeCreditActivity: "အခမဲ့ခရက်ဒစ် အစီအစဉ်",
        accountInfo: "အကောင့်အချက်အလက်",
        depositWithdraw: "ငွေသွင်း / ငွေထုတ်",
        welcome: "နံပါတ် ၁ အွန်လိုင်းကာစီနို {{name}} မှ ကြိုဆိုပါသည်",
        memberMenu: "အဖွဲ့ဝင်မီနူး",
        announce: "ကြေညာချက်:",
        maintenance: "ပြုပြင်ထိန်းသိမ်းနေသည်",
        noGames: "ဂိမ်းမတွေ့ပါ",
        play: "ကစားရန်",
        loading: "လုပ်ဆောင်နေသည်...",
        creditHistory: "ခရက်ဒစ်မှတ်တမ်း",
        sorryInconvenience: "အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်။",
        maintenanceMessage: "ဝန်ဆောင်မှုကို ပြုပြင်ထိန်းသိမ်းနေသည် ⚠️ အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်။",
        accessDeniedImage: "ဝင်ရောက်ခွင့်မရှိပါ",
        chooseCorrectPath: "စာမျက်နှာမတွေ့ပါ။ မှန်ကန်သောလမ်းကြောင်းကို ရွေးချယ်ပါ။",
        comingSoon: "မကြာမီ ရရှိနိုင်ပါမည်",
        promotionBalanceNote: "မှတ်ချက်။ ငွေသွင်းရာတွင် ပရိုမိုးရှင်းရယူထားပြီး နောက်တစ်ကြိမ်ငွေသွင်းမီ လက်ကျန်ခရက်ဒစ် ၁ ဘတ်ကျော် သို့မဟုတ် မပြီးဆုံးသေးသောလောင်းကြေးရှိကြောင်း စနစ်ကတွေ့ရှိပါက ငွေထုတ်ခြင်းကို ငြင်းပယ်ရန် သို့မဟုတ် စီမံခန့်ခွဲသူ၏ဆုံးဖြတ်ချက်အရ ခရက်ဒစ်ကို ပြန်လည်ရယူရန် ကုမ္ပဏီက အခွင့်အရေးရှိသည်။",
        bestOnlineLottery: "အကောင်းဆုံး အွန်လိုင်းထီ {{name}}",
        bestOnlineCasino: "အကောင်းဆုံး အွန်လိုင်းကာစီနို {{name}}",
        lotteryFooterDescription: "{{name}} သည် ထိုင်းနိုင်ငံ၏ ထိပ်တန်း အွန်လိုင်းထီ၊ စလော့၊ အားကစားနှင့် ဘာကာရက်ဝက်ဘ်ဆိုက်ဖြစ်ပြီး မြန်ဆန်သော အလိုအလျောက်ငွေသွင်း/ထုတ်ခြင်း၊ ပြေစာဖြင့် လွယ်ကူစွာငွေသွင်းခြင်းနှင့် ယုံကြည်စိတ်ချရသောဝန်ဆောင်မှုကို ပေးပါသည်။",
        casinoFooterDescription: "{{name}} သည် ထိုင်းနိုင်ငံ၏ ထိပ်တန်း စလော့၊ အားကစားနှင့် ဘာကာရက်ဝက်ဘ်ဆိုက်ဖြစ်ပြီး မြန်ဆန်သော အလိုအလျောက်ငွေသွင်း/ထုတ်ခြင်း၊ ပြေစာဖြင့် လွယ်ကူစွာငွေသွင်းခြင်းနှင့် ယုံကြည်စိတ်ချရသောဝန်ဆောင်မှုကို ပေးပါသည်။",
        tags: "တဂ်များ",
        casinoPartners: "ကာစီနို မိတ်ဖက်များ",
        acceptedPayments: "လက်ခံသော ငွေပေးချေမှုနည်းလမ်းများ",
        partnerLogo: "ကာစီနိုမိတ်ဖက် လိုဂို",
        bankLogo: "{{bank}} ဘဏ်လိုဂို",
        enablePoints: "ပွိုင့်စုဆောင်းမှုကို ဖွင့်ရန်",
        depositForPoint: "{{amount}} ဘတ် ငွေသွင်းပြီး ၁ ပွိုင့် ချက်ချင်းရယူပါ",
        redemptionHistory: "ဆုလဲလှယ်မှုမှတ်တမ်း",
        rewardList: "ဆုလက်ဆောင်များ",
        noRewardHistory: "ဆုလဲလှယ်မှုမှတ်တမ်း မရှိပါ",
        promotionImage: "{{name}} ပရိုမိုးရှင်းပုံ",
        rewardImage: "{{name}} ဆုလက်ဆောင်ပုံ",
        enterFreeCreditCode: "အခမဲ့ခရက်ဒစ်ရယူရန် ကုဒ်ထည့်ပါ",
        enterFreePointCode: "အခမဲ့ပွိုင့်ရယူရန် ကုဒ်ထည့်ပါ",
        freeBonus: "အခမဲ့ဘောနပ်စ်",
        bonusValidity: "{{start}} မှ {{end}} အထိ အသုံးပြုနိုင်သည်",
        fixedDepositImage: "ပုံမှန်ငွေသွင်းဘောနပ်စ် အသေးစိတ်",
        dayNumber: "ရက် {{day}}",
        tryAgainLater: "ကျေးဇူးပြု၍ ခဏကြာမှ ထပ်မံကြိုးစားပါ!",
        congratulations: "ဂုဏ်ယူပါသည်!",
        receivedCredits: "ခရက်ဒစ် {{amount}} ရရှိပါသည်",
        spinWheelWithPoints: "ကံစမ်းဘီးလှည့်ရန် နှိပ်ပါ (ပွိုင့် {{points}} ရှိသည်)",
        earnPointRule: "{{amount}} ဘတ်နှင့်အထက် ငွေသွင်းလျှင် ၁ ပွိုင့်ရမည်",
        spinCostRule: "ကံစမ်းဘီး ၁ ကြိမ်လှည့်ရန် ပွိုင့် {{points}} အသုံးပြုမည်",
      },
    },
  },
};

export default newgameCore;
